import AppTour from '@components/tour/AppTour';
import { TOUR_ID } from '@components/tour/tours';

/**
 * `AppTour` as checking the count sees it: its button sits beside Done, under the question.
 *
 * It mounts with the question, so its targets are there for the engine's once-on-mount check. No stages: it
 * explains the answers without giving one, and the look-alikes step is dropped until there are look-alikes.
 *
 * `onOpenChange` lets the page hold the check's keys (Y, N, U, arrows, Esc) and its own while the tour is open: the
 * tour's arrows would otherwise skip a track, and its Esc close the check.
 */
const CheckTour = ({ onOpenChange }) => (
	<AppTour tourId={TOUR_ID.VIDEO_CHECK} onOpenChange={onOpenChange} />
);

export default CheckTour;
